<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardBody>
            <BTabs>

              <CTab :title="$t('sidebars.addBuyDocument')">
                <AddDocument/>
              </CTab>
              <CTab :title="$t('tempBuyFactors')">
                <BuyDocumentList :selected_type="1"/>
              </CTab>
              <CTab :title="$t('buyList')">
                <BuyDocumentListFinal  :selected_type="2"/>
              </CTab>
            </BTabs>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
var items = [];
import BTabs from "../../tabs/BTabs";
import BuyDocumentList from "./BuyDocumentList";
import BuyDocumentListFinal from "./BuyDocumentListFinal";
import AddDocument from "../documents/AddDocument";
export default {
  name: 'Login',
  components: {
    BTabs,
    BuyDocumentList,
    BuyDocumentListFinal,
    AddDocument,

  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,

    }
  }, mounted() {
    this.$root.root_validate_errors = [];


  }, watch: {

  },
  methods: {

  }
}

</script>
